export default __webpack_public_path__ + "static/media/FAQ_2.e9c5584b.png";